module.exports = __webpack_public_path__ + "media/vue/assets/images/qr-codes/sg_getapp-8113cc18a3eb7a3abe64b58b33b426ce.png";